<template>
  <div class="wrapper">
    <div class="row">
      <div class="col-lg-12">
        <div id="filters">
          <div class="search col-lg-12 col-md-12">
            <div class="row">
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                  placeholder="Clients"
                  :options="f.clients"
                  label="name"
                  multiple
                  v-model="multiFilters['clients']"
                ></v-select>
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                  placeholder="Group by"
                  :options="groupBy"
                  label="label"
                  index="value"
                  v-model="filters['group']"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 m-t-sm">
            <button class="btn btn-xs btn-primary" @click="loadIssues">Search</button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <table class="hover table">
          <thead>
          <tr>
            <th>Client</th>
            <th>Issue</th>
            <th>Count</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(issue, i) in issues" :key="'issue-id-' + i">
            <td>{{ issue.client.name }}</td>
            <td>{{ issue.type }}</td>
            <td>{{ issue.count }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Values, Query } from '../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      issues: [],
      multiFilters: [],
      filters: {},
      groupBy: [
        {label: 'Client', value: 'client'},
        {label: 'Issue', value: 'issue'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [
    Values, Query
  ],
  mounted () {
    document.title = 'Issues Summary :: Reports :: PBN360 by Aphex Media'
    this.loadIssues()
  },
  methods: {
    loadIssues () {
      axios.get('/pbn/qa/tasks/summary?' + this.buildQuery(this.filters, this.multiFilters)).then(r => {
        this.issues = r.data.data
      }).catch(e => {
        this.$toastr.error(e, 'No issues for you')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/IssueSummary.vue